import CashCollectionSearchResponseBase from './base/CashCollectionSearchResponseBase';

/**
 * @class CashCollectionSearchResponse
 * @extends CashCollectionSearchResponseBase
 */
class CashCollectionSearchResponse extends CashCollectionSearchResponseBase {

}

export default CashCollectionSearchResponse;
